
/**
 * Valor por defecto para generales
 */
export const empresa = () => {
  return {
    banner: 0,
    boton_banner: ''
  };
};

/**
 * Variables
 */
export default {
  empresa: empresa()
};
